var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1CanadianWell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.11 59h4.53A19 19 0 0129 56h-6.21l.29-.29.93-.93L30.79 48l8 8h-5.64a15 15 0 0027 3h-.04zM44 51V24.78l-21-14.5L2 25.11V55h13.88l4.2-3.91L26 45.57V42h-6v9H6V27.22l17-12 17 11.69v24L44.12 55H74v-4H44zM34 30h-6v6h6v-6zm-16 6v-6h-6v6h6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Canadian_well.0b213355.svg";
export { SvgD1CanadianWell as ReactComponent };